var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64031 10.6305L6.27688 8.26725C6.24438 8.23462 6.21875 8.19819 6.2 8.15794C6.18125 8.11781 6.17188 8.07475 6.17188 8.02875C6.17188 7.93688 6.20294 7.857 6.26506 7.78912C6.32719 7.72137 6.40906 7.6875 6.51069 7.6875H11.4896C11.5912 7.6875 11.6731 7.72175 11.7352 7.79025C11.7973 7.85862 11.8284 7.93844 11.8284 8.02969C11.8284 8.05256 11.7933 8.13175 11.7232 8.26725L9.35994 10.6305C9.30569 10.6849 9.24956 10.7246 9.19156 10.7496C9.13356 10.7746 9.06975 10.7871 9.00012 10.7871C8.9305 10.7871 8.86669 10.7746 8.80869 10.7496C8.75069 10.7246 8.69456 10.6849 8.64031 10.6305Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.a82ade904ed7f795fa751fc24ba8e0b7.svg";
export { ForwardRef as ReactComponent };